<template>
  <div class="com-eco-table">
    <p class="lol-report-timeline-title">时间线</p>
    <div class="kill-line-section" v-for="item in ['blue', 'red']" :key="item">
      <div class="kill-line-item" :class="item">
        <img class="team-icon" v-hb-img.src="dataInfo[item].img" />
        <div class="kill-chart">
          <div
            class="kill-icon"
            v-for="(obj, index) in dataInfo[item].obj_kills"
            :key="obj.timestamp"
            :style="{
              left: `${Math.round((obj.timestamp / dataInfo.match_len) * 100)}%`,
            }"
            @click.stop="showKillDetail(item + index)"
          >
            <div
              v-if="active_kill_icon == item + index"
              class="kill-icon-prompt"
            >
              {{ obj.timestamp | formatTime }}
            </div>
            <img v-hb-img.src="obj.img" />
          </div>
        </div>
      </div>
    </div>
    <div class="kill-line-section-chart" @touchmove.prevent ref="chart"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts/highmaps';
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      active_kill_icon: '',
    };
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    getHeight(value) {
      return {
        height: Math.round((value / this.dataInfo.max) * 94) + 'px',
      };
    },
    showKillDetail(index) {
      this.active_kill_icon = index;
      let cb = () => {
        this.active_kill_icon = '';
        window.removeEventListener('click', cb);
      };
      window.addEventListener('click', cb);
    },
    drawChart() {
      let interval = (() => {
        let { max, min } = this.dataInfo.gold_chart.reduce(
          (pre, cur) => {
            if (cur.value > pre.max) {
              pre.max = cur.value;
            }
            if (cur.value < pre.min) {
              pre.min = cur.value;
            }
            return pre;
          },
          {
            max: -Infinity,
            min: Infinity,
          },
        );
        let temp = Math.abs(max - min) / 3;
        return temp < 1000 ? 1000 : Math.floor(temp / 1000) * 1000;
      })();
      Highcharts.chart(this.$refs['chart'], {
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        title: {
          text: null,
        },
        chart: {
          backgroundColor: 'transparent',
          type: 'spline',
          spacingBottom: 5,
          spacingLeft: 0,
          spacingRight: 0,
          spacingTop: 20,
        },
        xAxis: {
          gridLineWidth: 1,
          gridLineColor: '#F3F4F5',
          tickWidth: 0,
          tickColor: 'transparent',
          lineColor: '#F3F4F5',
          tickInterval: this.dataInfo.match_len / 4 - 10,
          lineWidth: 2,
          title: {
            text: null,
          },
          labels: {
            style: {
              'font-size': '10px',
              color: 'rgba(20, 25, 30, .4)',
            },
            y: 15,
            formatter: function () {
              let min = Math.floor(this.value / 60000),
                sec = Math.floor((this.value % 60000) / 1000);
              min = min < 10 ? '0' + min : min;
              sec = sec < 10 ? '0' + sec : sec;
              return min + ':' + sec;
            },
          },
        },
        yAxis: {
          gridLineWidth: 1,
          gridLineColor: '#F3F4F5',
          tickWidth: 0,
          tickInterval: interval,
          title: {
            text: null,
          },
          labels: {
            style: {
              'font-size': '10px',
              color: 'rgba(20, 25, 30, .4)',
            },
          },
        },
        tooltip: {
          backgroundColor: '#FFFFFF',
          borderColor: '#F3F4F5',
          borderRadius: 4,
          shared: false,
          useHTML: true,
          formatter: function () {
            if (this.y < 0) {
              let s = `
              <span class="lol-match-record-chart-tooltip-title" >${`${formatTime(this.x)}`}</span>
              <span class="lol-match-record-chart-tooltip-content">
                <span class="line-1" style="color: rgba(209, 46, 85, 1)">红方经济领先</span>
                <span class="line-2" style="color: rgba(209, 46, 85, 1)">${0 - this.y}</span>
              </span>
              `;
              return s;
            } else {
              let s = `
              <span class="lol-match-record-chart-tooltip-title" >${`${formatTime(this.x)}`}</span>
              <span class="lol-match-record-chart-tooltip-content" >
                <span class="line-1" style="color: rgba(57, 138, 212, 1)">蓝方经济领先</span>
                <span class="line-2" style="color: rgba(57, 138, 212, 1)">${this.y}</span>
              </span>
              `;
              return s;
            }
          },
        },
        plotOptions: {
          area: {
            // lineColor: '#538E38',
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 1,
                x2: 0,
                y2: 0,
              },
              stops: [
                [0, 'rgba(57, 138, 212, 0.03))'],
                [1, 'rgba(57, 138, 212, 0.3))'],
              ],
            },
            color: 'rgba(57, 138, 212, 1)',
            negativeColor: 'rgba(209, 46, 85, 1)',
            negativeFillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, 'rgba(209, 46, 85, 0.03)'],
                [1, 'rgba(209, 46, 85, 0.30)'],
              ],
            },
            marker: {
              radius: 0,
            },
            lineWidth: 2,
          },
        },
        series: [
          {
            type: 'area',
            pointStart: 0,
            // smooth: true,
            data: this.dataInfo.gold_chart.reduce((pre, cur) => {
              pre.push([cur.timestamp, cur.value]);
              return pre;
            }, []),
          },
        ],
      });
    },
  },
  computed: {
    chartList() {
      return this.dataInfo?.table_list?.data_list ?? [];
    },
    compareStyle() {
      let radiant = Math.round(
          (this.dataInfo.radiant_eco /
            (this.dataInfo.radiant_eco + this.dataInfo.dire_eco)) *
            100,
        ),
        dire =
          Math.round(
            (1 -
              this.dataInfo.radiant_eco /
                (this.dataInfo.radiant_eco + this.dataInfo.dire_eco)) *
              100,
          ) + 0.3;
      return {
        background: `
          left top / ${radiant}% 100% linear-gradient(270deg, #92A525 0%, rgba(146, 165, 37, 0.70) 100%) no-repeat,
          right top / ${dire}% 100% linear-gradient(90deg, #C23C2A 0%, rgba(194, 60, 42, 0.70) 100%) no-repeat
        `,
      };
    },
    differenceValue() {
      let value = this.dataInfo.radiant_eco - this.dataInfo.dire_eco;
      return {
        value: Math.abs(value),
        class: value < 0 ? 'dire' : 'radiant',
      };
    },
  },
  filters: {
    formatTime(time) {
      return formatTime(time);
    },
  },
};

function formatTime(time) {
  let min = Math.floor(time / 60000),
    sec = Math.floor((time % 60000) / 1000);
  min = min < 10 ? '0' + min : min;
  sec = sec < 10 ? '0' + sec : sec;
  return `${min}:${sec}`;
}
</script>

<style lang="less">
.com-eco-table {
  width: 100%;
  height: 283px;
  padding: 10px;
  border-radius: 8px;
  .lol-report-timeline-title {
    height: 17px;
    color: rgba(20, 25, 30, 1);
    font-size: 12px;
    line-height: 17px;
  }
  .kill-line-section {
    margin-top: 8px;
    border-radius: 5px;
    // overflow: hidden;
    .kill-line-item {
      display: flex;
      align-items: center;
      height: 30px;
      width: 100%;
      padding-left: 6px;
      padding-right: 20px;
      &:nth-of-type(1) {
        border-radius: 5px 5px 0 0;
      }
      &:nth-of-type(2) {
        border-radius: 0 0 5px 5px;
      }
      &.blue {
        background: rgba(57, 138, 212, 0.08);
      }
      &.red {
        background: rgba(209, 46, 85, 0.07);
      }
      .team-icon {
        width: 24px;
        height: 24px;
        object-fit: scale-down;
      }
      .kill-chart {
        position: relative;
        flex: 1;
        width: 0;
        height: 16px;
        margin-left: 6px;
        .kill-icon {
          position: absolute;
          top: 0;
          width: 16px;
          height: 16px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
          .kill-icon-prompt {
            position: absolute;
            bottom: 120%;
            left: 50%;
            padding: 12px 16px;
            font-size: 14px;
            font-weight: 700;
            line-height: 17px;
            white-space: nowrap;
            border-radius: 6px;
            background: #fff;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
            transform: translate(-50%, 0);
          }
        }
      }
    }
  }
  .kill-line-section-chart {
    width: 100%;
    height: 170px;
    margin-top: 8px;
  }
  .lol-match-record-chart-tooltip-title {
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: rgba(20, 25, 30, 1);
  }
  .lol-match-record-chart-tooltip-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .line-1 {
      margin-top: 9px;
      font-size: 14px;
    }
    .line-2 {
      margin-top: 2px;
      font-size: 14px;
      font-weight: 700;
    }
  }
}
</style>
